<template>
	<div>
    <!--
		<el-row class="breadcrumb-bar">
			<el-col :span="10">
				&lt;!&ndash;<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="fa fa-sitemap"></i> 首页</el-breadcrumb-item>
					<div v-if="$route.matched.length > 1">
						<el-breadcrumb-item v-for="item in $route.matched" :key="item.meta.title" v-if="item.meta && item.meta.title">{{ item.meta.title }}</el-breadcrumb-item>
					</div>
				</el-breadcrumb>&ndash;&gt;
				<span class="nav-title">{{this.$route.meta.title}}</span>
			</el-col>
			<el-col :span="4" :offset="10" class="nav-tools">
				<el-button size="mini" @click="refresh()"><i class="fa fa-refresh"></i> 刷新</el-button>
				<el-button size="mini" @click="goBack()"><i class="fa fa-arrow-left"></i> 返回</el-button>

				&lt;!&ndash;<div class="cur-time"><i class="fa fa-calendar"></i> {{ curTime }}</div>&ndash;&gt;
			</el-col>
		</el-row>-->

		<el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
			<div class="main-content content layout-compact" ref="main-content">
				<transition name="fade" mode="out-in">
					<router-view ref="childRouter"></router-view>
				</transition>
			</div>
		</el-scrollbar>
	</div>
</template>

<script>
import { parseTime } from '@/utils/index'
export default {
	name: 'main-content',
	data: function() {
		return {
			mainH: 100,
			curNav: this.$route.meta.title,
			reqBack: true,
			curTime: parseTime(new Date(), '今天是{y}年{m}月{d}日 星期{a}'),
		}
	},
	methods: {
		refresh(){
			this.$refs['childRouter'].created()
			// this.$router.go(0)
		},
		goBack: function() {
			this.$router.go(-1)
		}
	}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.breadcrumb-bar {
	border-bottom: 1px solid #dfdfdf;
	background-color: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

	.el-breadcrumb {
		font-size: 12px;
		height: 45px;
		line-height: 45px;
		padding: 0;
	}
	.cur-time,.nav-tools,.nav-title {
		height: 45px;
		line-height: 45px;
	}
	.nav-title{
		font-size: 12px;
		display: inline-block;
		&::before{
			content: ' ';
			padding-left: 5px;
			border-left: 3px solid #00a0e9;
			box-shadow: 0 2px 8px #f0f1f2
		}
	}
	.nav-tools{
		text-align: right;
		padding-right: 15px;
	}
}

.dashboard-stat {
	border: 1px solid rgba(228, 228, 228, 1);
	padding: 5px 7px;
	display: block;
	margin-bottom: 25px;
	overflow: hidden;
	border-radius: 4px;
	background-color: #fff;
	padding: 10px 25px;
	&:after {
		content: ' ';
		display: table;
		clear: both;
	}
	.visual {
		font-size: 58px;
		color: #1abc9c;
		float: left;
		width: 40%;
		min-height: 50px;
		text-align: center;
	}
	.details {
		float: left;

		.number {
			margin-top: 20px;
			margin-left: 30px;
			text-align: right;
		}

		.desc {
			font-size: 18px;
			font-weight: 700;
		}

		.count {
			font-size: 16px;
			font-weight: 700;
		}
	}
}

.content-container .el-scrollbar__wrap {
	overflow-x: hidden;
}
</style>
